import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer id="footer" className="footer dark-background">
            <div className="container footer-top">
                <div className="row gy-4">
                    <div className="col-lg-4 col-md-6 footer-about">
                        <Link to="/" className="logo d-flex align-items-center">
                            <span className="sitename">M365Insights.net</span>
                        </Link>
                        <div className="footer-contact pt-3">
                            <p>Marc A. Schröder-Zhou</p>
                            <p>Bad Vilbel - Germany</p>
                            <p className="mt-3"><strong>Phone:</strong> <span>+49 151 41455998</span></p>
                            <p><strong>Email:</strong> <span>info@dev-sky.net</span></p>
                        </div>
                        <div className="social-links d-flex mt-4">
                            <a href="https://twitter.com/marcandrezhou" aria-label="Twitter">
                                <i className="bi bi-twitter-x"></i>
                            </a>
                            <a href="https://www.youtube.com/channel/UCvVuOjixE050egnWNcoSZ-Q?app=desktop" aria-label="Youtube">
                                <i className="bi bi-youtube"></i>
                            </a>
                            <a href="https://www.dev-sky.net/blog.html" aria-label="Blog">
                                <i className="bi bi-newspaper"></i>
                            </a>
                            <a href="https://www.linkedin.com/in/dev-schroeder/" aria-label="LinkedIn">
                                <i className="bi bi-linkedin"></i>
                            </a>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-3 footer-links">
                        <h4>SharePoint Online</h4>
                        <ul>
                            <li><a href="https://learn.microsoft.com/en-us/sharepoint/" target="_blank" rel="noopener noreferrer">SharePoint Online</a></li>
                            <li><a href="https://support.microsoft.com/en-us/office/sharepoint-online-help-and-learning-79a02e97-cbdd-405d-afaf-3256e0d5cb14" target="_blank" rel="noopener noreferrer">Getting Started</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/sharepoint/sharepoint-online" target="_blank" rel="noopener noreferrer">Sites & Pages</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/sharepoint/lists-and-libraries-overview" target="_blank" rel="noopener noreferrer">Lists & Libraries</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/sharepoint/dev" target="_blank" rel="noopener noreferrer">Customization</a></li>
                        </ul>
                    </div>

                    <div className="col-lg-2 col-md-3 footer-links">
                        <h4>Power Platform</h4>
                        <ul>
                            <li><a href="https://learn.microsoft.com/en-us/power-platform/" target="_blank" rel="noopener noreferrer">Power Platform</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/power-apps" target="_blank" rel="noopener noreferrer">Power Apps</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/power-automate" target="_blank" rel="noopener noreferrer">Power Automate</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/power-bi" target="_blank" rel="noopener noreferrer">Power BI</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/microsoft-copilot-studio" target="_blank" rel="noopener noreferrer">Copilot Studio</a></li>
                        </ul>
                    </div>

                    <div className="col-lg-2 col-md-3 footer-links">
                        <h4>Microsoft CoPilot</h4>
                        <ul>
                            <li><a href="https://www.microsoft.com/en-us/microsoft-365/copilot-learning-center" target="_blank" rel="noopener noreferrer">Microsoft CoPilot</a></li>
                            <li><a href="https://docs.microsoft.com/en-us/microsoft-365-copilot" target="_blank" rel="noopener noreferrer">Overview</a></li>
                            <li><a href="https://support.microsoft.com/en-us/microsoft-365-copilot" target="_blank" rel="noopener noreferrer">Help & Learning</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/microsoft-365-copilot" target="_blank" rel="noopener noreferrer">Tutorials</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/power-platform/copilot" target="_blank" rel="noopener noreferrer">Power Platform Copilot</a></li>
                        </ul>
                    </div>

                    <div className="col-lg-2 col-md-3 footer-links">
                        <h4>M365 in common</h4>
                        <ul>
                            <li><a href="https://learn.microsoft.com/en-us/microsoft-365/" target="_blank" rel="noopener noreferrer">M365 in common</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/microsoft-365/integration" target="_blank" rel="noopener noreferrer">Integration</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/microsoft-365/collaboration" target="_blank" rel="noopener noreferrer">Collaboration</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/microsoft-365/security" target="_blank" rel="noopener noreferrer">Security</a></li>
                            <li><a href="https://learn.microsoft.com/en-us/training/microsoft365/" target="_blank" rel="noopener noreferrer">Training</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="container copyright text-center mt-4">
                <p>© <span>Copyright</span> <strong className="px-1 sitename">My Knowledge Portal</strong> <span>All Rights Reserved</span></p>
                <div className="mb-2">
                    <button
                        className="btn btn-link btn-sm p-0 text-white-50"
                        style={{ fontSize: '0.8rem', textDecoration: 'underline dotted' }}
                        onClick={() => window.dispatchEvent(new CustomEvent('mkp:open-cookie-consent'))}
                    >
                        Cookie Settings
                    </button>
                </div>
                <div className="credits">
                    {/* All the links in the footer should remain intact. */}
                    {/* You can delete the links only if you've purchased the pro version. */}
                    {/* Licensing information: https://bootstrapmade.com/license/ */}
                    {/* Purchase the pro version with working PHP/AJAX contact form: [buy-url] */}
                    Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a> Distributed by <a href="D">ThemeWagon</a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
